import Actions                           from 'Redux/Actions';
import { EventParentCategoryRepository } from 'Domain/Repositories';
import { ofType }                        from 'redux-observable';
import { from }                          from 'rxjs';
import { mergeMap, catchError }          from 'rxjs/operators';
import { TEpic }                         from 'Redux/Config';
import { message }                       from 'antd';

export const updateEventParentCategoryEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.updateEventParentCategoryRequest.type),
    mergeMap(action => from(EventParentCategoryRepository.update(action.payload.id, action.payload.formData))
      .pipe(
        mergeMap((eventParentCategory) => {
          message.success('Die Speicherung der Event Kategorie erfolgreich.');

          return from([
            Actions.updateEventParentCategorySuccess({ eventParentCategory }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.updateEventParentCategoryFailure({ error })
          ]);
        })
      )
    ),
  );
};
